const FETCH_NATIONALITIES_REQUEST = "FETCH_NATIONALITIES_REQUEST";
const FETCH_NATIONALITIES_SUCCESS = "FETCH_NATIONALITIES_SUCCESS";
const FETCH_NATIONALITIES_FAILURE = "FETCH_NATIONALITIES_FAILURE";

export default {
  FETCH_NATIONALITIES_REQUEST,
  FETCH_NATIONALITIES_SUCCESS,
  FETCH_NATIONALITIES_FAILURE,
};
